import script from "./FirmCurasept.vue?vue&type=script&lang=ts&setup=true"
export * from "./FirmCurasept.vue?vue&type=script&lang=ts&setup=true"

import "./FirmCurasept.vue?vue&type=style&index=0&id=4fb052ba&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fb052ba"]])

export default __exports__